module.exports = __webpack_public_path__ + "img/bl-back.df8428d9.png";